<template>
<div class="chapter">
<div class="inner_page">
<div id="foreword">
<a id="page_xvii">
</a><p class="booktitle paracenter" id="for" style="margin-top:3em;font-size:1.5em"><a id="page_xvii"></a><a href="#/text/08_contents#for"><span class="small">FOREWORD</span></a></p>
<p class="paracenter"><img alt="image" src="images/forward-1.jpg" style="max-width:100%"/></p>
<p class="paracenter" style="margin-top:1.6em;">by</p>
<p class="paracenter">Major General R. A. Pett, MBE <br/>Colonel, 6th Queen Elizabeth’s Own Gurkha Rifles</p>
<p class="paranoindent1" style="margin-top:2em;">THIS book tells the story of the 6th Gurkhas from their raising as the Cuttack Legion in 1817 to the merger with the other British Army regiments of Gurkha Rifles in 1994. It is an adventure story to rank with any in fact or fiction, here superbly told by James Lunt, who has captured that unique spirit of the 6th Gurkhas.</p>
<p class="paraindent1">A curtain of mystique surrounds the fierce hillmen of Nepal. This book lifts a corner of that curtain and illuminates the stoicism and heroism of both the Gurkha riflemen and their exceptional officers, British and Gurkha alike. It tells, for example, the story of the 1st Battalion at Gallipoli, where they alone succeeded in reaching the heights of Sari Bair, but at the cost of every British officer dead or wounded, save only the Medical Officer. Equally enthralling is the account of the 2nd Battalion’s hard slogging alongside the 14th/20th King’s Hussars in Italy in the Second World War, and the award of two VCs in the Chindit campaign, to Captain Michael Allmand and Rifleman Tulbahadur Pun of the 3rd Battalion.</p>
<p class="paraindent1">But this book also fills in the periods in between the big wars – on the North-West Frontier; in the jungles of Malaya, Borneo, Brunei or Belize; on the Sino-Hong Kong Border, or the sports field, or the Century Range at Bisley; or just … soldiering. Throughout the book shines that ineluctable spirit of the 6th Gurkhas and the sheer, infectious fun of serving with those<a id="page_xviii"> “Bravest of brave, most generous of the generous”. For to serve with Gurkhas is not just a privilege. It is, truly, a pleasure. Within these pages are to be found the essence of that privilege and pleasure.</a></p><a id="page_xviii">
<p class="paracenter" style="margin-top:1em;">Jai Sixth!</p>
</a></div><a id="page_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_foreword.vue?624f0fce